import axios, { type AxiosInstance } from "axios";
import { getToken, clearToken } from "./auth-token";
import { useAuthStore } from "@/stores/auth-store";

const BASE = (import.meta.env.VITE_API_BASE as string | undefined) ?? "/api/v1";

export const api: AxiosInstance = axios.create({
  baseURL: BASE,
  timeout: 30_000,
});

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const viewEntity = useAuthStore.getState().viewEntity;
  if (viewEntity !== "ALL") {
    config.headers["x-view-entity"] = viewEntity;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      clearToken();
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  },
);
